// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bee_a bhv_cw bhv_jx bhv_jo bhv_rh bhv_vf"};